export default __webpack_public_path__ + "static/media/mediaDocument.8315e09b.svg";